import { getUserSettings } from "@library/Services/UserSettings";
import { UserSettings } from "./UserSettings";

export function useUserSettings()
{
    const store = getUserSettings( UserSettings );
    return store.instance as UserSettings;
}

